import { useAuth } from '../App';
import { formatDateTime as formatDateTimeUtil, formatDate as formatDateUtil, formatTime as formatTimeUtil } from '../utils/dateTimeFormatter';

export const useDateTimeFormat = () => {
  const { user } = useAuth();
  
  const preferences = {
    timeFormat: user?.time_format || '24',
    dateFormat: user?.date_format || 'DD/MM/YYYY',
  };

  const formatDateTime = (dateTimeStr, options = {}) => {
    return formatDateTimeUtil(dateTimeStr, { ...preferences, ...options });
  };

  const formatDate = (dateTimeStr, options = {}) => {
    return formatDateUtil(dateTimeStr, { ...preferences, ...options });
  };

  const formatTime = (dateTimeStr, options = {}) => {
    return formatTimeUtil(dateTimeStr, { ...preferences, ...options });
  };

  return {
    formatDateTime,
    formatDate,
    formatTime,
    preferences
  };
};
